document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', (e) => {
        // Révéler le verso
        if (e.target.closest('.js-flip-reveal')) {
            e.preventDefault();
            const card = e.target.closest('.wp-block-kaloncom-flip-card');
            if (card) card.classList.add('is-flipped');
        }
        
        // Retourner au recto
        if (e.target.closest('.js-flip-return')) {
            e.preventDefault();
            const card = e.target.closest('.wp-block-kaloncom-flip-card');
            if (card) card.classList.remove('is-flipped');
        }
    });
});